// Antes que cornerstone: evita canvas 2d desynchronized (rayas negras en Samsung/Android)
import './utils/patchCanvasNoDesync'
import './i18n'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { scheduleSplashHide } from './pwa/splashScreen'
import WebFontLoader from 'webfontloader'
import {Provider} from 'react-redux'
import store from './store'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import * as cornerstone from 'cornerstone-core'
import * as cornerstoneTools from 'cornerstone-tools'

// Polyfill robusto para process - asegurar que esté siempre disponible
(function() {
  // Función para crear el polyfill de process
  function createProcessPolyfill() {
    return {
      env: {
        NODE_ENV: 'development',
        PUBLIC_URL: ''
      },
      version: 'v16.0.0',
      versions: {},
      platform: 'browser',
      arch: 'x64',
      argv: [],
      cwd: function() { return '/'; },
      chdir: function() {},
      nextTick: function(callback) { setTimeout(callback, 0); },
      exit: function() {},
      kill: function() {},
      umask: function() { return 0; },
      uptime: function() { return 0; },
      hrtime: function() { return [0, 0]; },
      memoryUsage: function() { return {}; },
      binding: function() { return {}; },
      _events: {},
      _maxListeners: 10,
      addListener: function() {},
      on: function() {},
      once: function() {},
      removeListener: function() {},
      removeAllListeners: function() {},
      emit: function() {},
      listeners: function() { return []; },
      listenerCount: function() { return 0; },
      setMaxListeners: function() {},
      getMaxListeners: function() { return 10; }
    };
  }
  
  // Función para asegurar que process esté disponible
  function ensureProcess() {
    var processPolyfill = createProcessPolyfill();
    
    // Solo asignar si process no existe o no es válido
    try {
      if (typeof global !== 'undefined' && (!global.process || global.process.env === undefined)) {
        global.process = processPolyfill;
      }
    } catch (e) {
      // Ignorar si no se puede asignar
    }
    
    try {
      if (typeof window !== 'undefined' && (!window.process || window.process.env === undefined)) {
        window.process = processPolyfill;
      }
    } catch (e) {
      // Ignorar si no se puede asignar (puede ser de solo lectura)
    }
    
    try {
      // eslint-disable-next-line no-undef
      if (typeof globalThis !== 'undefined' && (!globalThis.process || globalThis.process.env === undefined)) {
        // eslint-disable-next-line no-undef
        globalThis.process = processPolyfill;
      }
    } catch (e) {
      // Ignorar si no se puede asignar
    }
    
    try {
      // eslint-disable-next-line no-restricted-globals
      if (typeof self !== 'undefined' && (!self.process || self.process.env === undefined)) {
        // eslint-disable-next-line no-restricted-globals
        self.process = processPolyfill;
      }
    } catch (e) {
      // Ignorar si no se puede asignar
    }
    
    // Intentar asignar directamente solo si no existe
    try {
      if (typeof process === 'undefined') {
        // eslint-disable-next-line no-native-reassign
        process = processPolyfill;
      }
    } catch (e) {
      // Ignorar si no se puede asignar directamente
    }
    
    return processPolyfill;
  }
  
  // Verificar si process ya existe, si no, crearlo
  if (typeof process === 'undefined') {
    console.log('Process not found, creating polyfill...');
    ensureProcess();
  }
  
  // Verificar periódicamente que process siga disponible
  setInterval(function() {
    if (typeof process === 'undefined') {
      console.warn('Process polyfill lost in index.js, reinitializing...');
      ensureProcess();
    }
  }, 2000);
  
  console.log('Process polyfill verified in index.js');
})();

// Exponer CornerstoneTools globalmente para que esté disponible en window
if (typeof window !== 'undefined') {
  window.cornerstone = cornerstone
  window.cornerstoneTools = cornerstoneTools
  console.log('🔧 CornerstoneTools expuesto globalmente en window.cornerstoneTools')
}

WebFontLoader.load({
    google: {
        families: ['Roboto:300,400,500,700', 'Material Icons'],
    },
})

//store.subscribe(() => console.log('store updated:', store.getState()));

const theme = createTheme({
    overrides: {
        MuiFormControlLabel: {
            label: {
                fontSize: '0.85em'
            },
        },
        MuiFormLabel: {
            root: { 
                '&$focused': {
                    color:'#CCCCCC',
                },   
            }
         
        }
    },
    palette: {
        primary: {
            main: '#1565c0', // Azul más sutil y menos resaltante
        },
        secondary: {
            main: '#888888',
        },
        type: 'dark',
    },
  })

  
ReactDOM.render(
    <Provider store={store}>
        <MuiThemeProvider theme = { theme }>
            <App />
        </MuiThemeProvider>
    </Provider>, 
    document.getElementById('root'),
    () => scheduleSplashHide()
)

// Marker de build: si NO lo ves en consola, el browser está con main.chunk.js cacheado (Cloudflare)
console.warn('[UDV-BUILD] 2026-10-30-v0.20.97-hanging-editor')
